var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "param(fill)",
    d: "m17.294 6 .706.706L12.705 12 18 17.294l-.706.706L12 12.705 6.706 18 6 17.294 11.295 12 6 6.706 6.706 6 12 11.295 17.294 6z",
    fillRule: "evenodd"
  })));
};
export default SvgClose;